import styled from "@emotion/styled";
import { fontMerriweather, fontRobotoCondensed } from "@product/scmp-sdk";

import { SponsorHeadline } from "~/components/content/content-headline/styles";
import { ContentItemHomeSecondary } from "~/components/content/content-item-render/variants/home-secondary";
import {
  ActionBar,
  Headline,
} from "~/components/content/content-item-render/variants/home-secondary/styles";
import { HomeSponsorTagContainer } from "~/components/sponsor-tag/styles";

export const StyledContentItemHomeSecondary = styled(ContentItemHomeSecondary)``;

export const Title = styled.div`
  margin-block-end: 20px;

  color: #00000080;
  font-size: 20px;
  font-family: ${fontRobotoCondensed};
`;

export const MostPopularItems = styled.div`
  display: flex;
  flex-flow: column nowrap;

  margin-block-end: 20px;
  padding-block-end: 32px;
  border-block-end: 1px solid #000000;

  ${props => props.theme.breakpoints.between("tablet", "homeDesktop")} {
    flex-flow: row nowrap;
    gap: 32px;

    margin-block-end: 16px;
  }
`;

export const MostPopularItem = styled.div`
  display: flex;
  flex: 1;
  flex-flow: row nowrap;
  gap: 12px;
  align-items: center;

  ${props => props.theme.breakpoints.between("tablet", "homeDesktop")} {
    flex-flow: column nowrap;
    align-items: flex-start;
  }

  ${Headline}, ${SponsorHeadline} {
    margin-block-end: 0;

    font-weight: 400;
    font-size: 15px;
    font-family: ${fontMerriweather};
    line-height: 21px;
  }

  ${ActionBar}, ${HomeSponsorTagContainer} {
    display: none;
  }
`;

export const DisplayNumber = styled.div`
  color: #4585ff;
  font-weight: 300;
  font-size: 48px;
  font-family: ${fontRobotoCondensed};
  line-height: 56px;
`;

export const Container = styled.div`
  padding: 20px;

  border-radius: 8px;

  outline: 1px solid #00000033;

  ${MostPopularItem}:not(:first-child) {
    margin-block-start: 20px;
    padding-block-start: 20px;
    border-block-start: 1px solid rgba(0, 0, 0, 0.1);

    ${props => props.theme.breakpoints.between("tablet", "homeDesktop")} {
      margin-block-start: 0;
      padding-block-start: 0;
      border-block-start: none;
    }
  }
`;

export const TrendingTopics = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;
